export default "__VITE_ASSET__DqDhyC1g__"